import { render, staticRenderFns } from "./myShare.vue?vue&type=template&id=e8a5b6dc&scoped=true&"
import script from "./myShare.vue?vue&type=script&lang=js&"
export * from "./myShare.vue?vue&type=script&lang=js&"
import style0 from "./myShare.vue?vue&type=style&index=0&id=e8a5b6dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a5b6dc",
  null
  
)

export default component.exports